import { z } from 'zod';

import { parseRateInput } from '@/entities/service-catalog';

// Every field is a string, `''` meaning empty — `undefined` would restore react-hook-form's
// `defaultValues` instead of refusing the submit.
export const saveServiceFormSchema = z
    .object({
        code: z.string().trim().min(1, 'Select code'),
        description: z
            .string()
            .trim()
            .min(
                1,
                'Enter description. This description will appear on superbills and client invoices',
            ),
        makeDefault: z.boolean(),
        rate: z.string().trim().min(1, 'Enter default rate'),
        duration: z
            .string()
            .trim()
            .min(1, 'Enter duration')
            .refine((value) => Number.parseInt(value, 10) !== 0, 'Enter duration greater than 0'),
    })
    .transform((value) => ({
        code: value.code,
        description: value.description,
        makeDefault: value.makeDefault,
        rateCents: parseRateInput(value.rate),
        durationMinutes: Number.parseInt(value.duration, 10),
    }));

export type SaveServiceFormValues = z.input<typeof saveServiceFormSchema>;
export type SaveServiceFormOutput = z.output<typeof saveServiceFormSchema>;
